// deno-lint-ignore-file ban-unused-ignore no-explicit-any no-empty-interface
///////////////////////////////////
// !!! DO NOT EDIT THIS FILE !!! //
///////////////////////////////////

import type { SlackAPIResponse } from "../response";
export type AppsEventAuthorizationsListResponse = SlackAPIResponse & {
  authorizations?: Authorization[];
  error?: string;
  needed?: string;
  ok: boolean;
  provided?: string;
};

export interface Authorization {
  enterprise_id?: string;
  is_bot?: boolean;
  is_enterprise_install?: boolean;
  team_id?: string;
  user_id?: string;
}
